// 12 offices with approximate latitude/longitude
// Converted to SVG coordinates on a 1000x500 equirectangular projection
// x = (lon + 180) * (1000 / 360)
// y = (90 - lat) * (500 / 180)
//
// label_anchor: "start" | "end" | "middle" — SVG text-anchor
// label_dx, label_dy: pixel offset from marker for the text label (manual de-cluttering)

export const OFFICES = [
  { key: "port-louis", name: "Port Louis", country_fr: "Île Maurice", country_en: "Mauritius",
    lat: -20.16, lon: 57.50, headquarters: true,
    label_anchor: "start", label_dx: 10, label_dy: -10 },

  // West Africa cluster — fan labels out vertically to avoid overlap
  { key: "dakar", name: "Dakar", country_fr: "Sénégal", country_en: "Senegal",
    lat: 14.69, lon: -17.44,
    label_anchor: "end", label_dx: -10, label_dy: -8 },
  { key: "conakry", name: "Conakry", country_fr: "Guinée", country_en: "Guinea",
    lat: 9.51, lon: -13.71,
    label_anchor: "end", label_dx: -10, label_dy: 14 },
  { key: "abidjan", name: "Abidjan", country_fr: "Côte d'Ivoire", country_en: "Ivory Coast",
    lat: 5.36, lon: -4.00,
    label_anchor: "middle", label_dx: 0, label_dy: 20 },
  { key: "libreville", name: "Libreville", country_fr: "Gabon", country_en: "Gabon",
    lat: 0.42, lon: 9.46,
    label_anchor: "start", label_dx: 10, label_dy: 18 },
  { key: "abuja", name: "Abuja", country_fr: "Nigéria", country_en: "Nigeria",
    lat: 9.07, lon: 7.49,
    label_anchor: "start", label_dx: 10, label_dy: -8 },

  // Americas
  { key: "new-york", name: "New York", country_fr: "États-Unis", country_en: "United States",
    lat: 40.71, lon: -74.00,
    label_anchor: "end", label_dx: -10, label_dy: -8 },

  // Southern Africa
  { key: "durban", name: "Durban", country_fr: "Afrique du Sud", country_en: "South Africa",
    lat: -29.86, lon: 31.02,
    label_anchor: "start", label_dx: 10, label_dy: 4 },

  // Europe — London and Zurich are close, separate vertically
  { key: "london", name: "London", country_fr: "Royaume-Uni", country_en: "United Kingdom",
    lat: 51.51, lon: -0.13,
    label_anchor: "end", label_dx: -10, label_dy: -6 },
  { key: "zurich", name: "Zurich", country_fr: "Suisse", country_en: "Switzerland",
    lat: 47.38, lon: 8.54,
    label_anchor: "start", label_dx: 10, label_dy: 18 },

  // Asia — HK and Singapore — separate horizontally
  { key: "hong-kong", name: "Hong Kong", country_fr: "Chine", country_en: "China",
    lat: 22.32, lon: 114.17,
    label_anchor: "start", label_dx: 10, label_dy: -8 },
  { key: "singapore", name: "Singapore", country_fr: "Singapour", country_en: "Singapore",
    lat: 1.35, lon: 103.82,
    label_anchor: "end", label_dx: -10, label_dy: 18 },
];

// Convert lat/lon to SVG coordinates (1000 x 500 viewport)
export function projectToSVG(lat, lon, width = 1000, height = 500) {
  const x = (lon + 180) * (width / 360);
  const y = (90 - lat) * (height / 180);
  return { x, y };
}
